// src/config/routeConfig.js
export const routeLayoutConfig = {
  '/calendar': {
    sx: { maxWidth: 'none' },
  },
  '/team-calendar': {
    sx: { maxWidth: 'none' },
  },
  '/dashboard': {
    sx: { maxWidth: 'none' },
  },
  '/tasks': {
    sx: { maxWidth: 'none' },
  },
  '/equipment': {
    sx: { maxWidth: 'none' },
  },
  '/files': {
    sx: { maxWidth: 'none' },
  },
  '/home': {
    hideBreadcrumbs: true,
    transparentBg: true,
    sx: { maxWidth: 'none', p: 0, minHeight: '100%' },
  }
};

// Default configuration
export const defaultLayoutConfig = {
  sx: { maxWidth: 'none' },
};

// Helper function to get layout config for current route
export const getLayoutConfig = (pathname) => {
  // Find the most specific match
  const matchedRoute = Object.keys(routeLayoutConfig).find(route => {
    return pathname.startsWith(route);
  });

  return matchedRoute ? routeLayoutConfig[matchedRoute] : defaultLayoutConfig;
};